// extracted by mini-css-extract-plugin
export default {"paymentIcon":"style_paymentIcon__LcKwj"};